import { gql } from '@apollo/client';

import { Department } from '../profile/types/department';

export const GET_DEPARTMENTS = gql`
  query getDepartments($filter: DepartmentsFilters) {
    departments: allDepartments(filter: $filter) {
      id
      name
    }
  }
`;

export interface GetDepartmentsQuery {
  departments: Department[];
}
